import { io } from "socket.io-client";

const base = (process.env.REACT_APP_SOCKET_BASE || "").trim();
const path = process.env.REACT_APP_SOCKET_PATH || "/socket.io";

export const socket = io(base || undefined, {
  path,
  transports: ["websocket", "polling"],
  withCredentials: true,
  // Détection rapide des coupures (important sur mobile Android)
  pingInterval: 10000,   // ping toutes les 10s (défaut 25s)
  pingTimeout: 8000,     // déclare mort après 8s sans pong (défaut 20s)
  reconnectionDelay: 500,
  reconnectionDelayMax: 3000,
});

socket.on("connect", () => {
  console.log("🌐 WS connected:", socket.id);
});

socket.on("connect_error", (err) => {
  console.error("❌ WS connection error:", err.message);
});

// ─── Resync sur retour d'arrière-plan (Android / veille écran) ───────────────
// Quand l'écran se rallume ou que l'onglet redevient visible, on force un
// getPatients pour rattraper les events manqués pendant la suspension.
function resyncIfNeeded() {
  if (socket.connected) {
    socket.emit("getPatients");
  } else {
    socket.connect();
  }
}

if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      resyncIfNeeded();
    }
  });
}

if (typeof window !== "undefined") {
  // Reconnexion après coupure réseau (mode avion, wifi cut, etc.)
  window.addEventListener("online", () => {
    resyncIfNeeded();
  });
}
